import { useMemo, useEffect, useState } from "react";
import styles from "./edit.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import { TRANSMISSION_TYPES, TYPE_TYPES } from '../../../../constants/salePost';
import { MyPublicationEditProps } from '../../../../interfaces/pages';
import { addPointsInText, capitalize, formatInput, removePointsInText } from "../../../../helpers/app";
import { optionsAccidentsReported, optionsPersonalUse, optionsSoleOwner } from "../../../../constants/app";
import { Skeleton } from "@mui/material";
import { YesNoTypes } from '../../../../interfaces/types';
import { COLORS, FUEL_TYPES } from "../../../../constants/Publication";
import ButtonShared from "../../../../components/Button/Button";
import ProfileCard from "../../../../components/ProfileCard";
import Slider from "../../../../components/Slider";
import TextFieldShared from "../../../../components/TextField";
import SelectShared from "../../../../components/Select";
import { useToast } from "../../../../helpers/hooks";
import { images } from "../../../../constants/images";
import { VehiclePost } from '../../../../interfaces/publication';
import { myPubEditBreadCrumb } from "../../../../constants/breadCrumbs";
import Icon from '@mdi/react';
import { mdiClose, mdiAlertCircleOutline, mdiPencil } from '@mdi/js';
import LinzeAiItemLoader from "./LinzeAiItem/LinzeAiItemLoader";
import PicturesModal from "./PicturesModal";
import FeaturesModal from "./FeaturesModal";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Chip,
  Modal,
  Box,
  Button,
  IconButton,
  Grid,
  Divider,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { getBrands } from "../../../../actions/publications";
import { setType, setYear } from "../../../../reducers/publications";
import { setTransmission } from "../../../../actions/salePost";
import CustomFileUploader from '../../../../components/CustomFileUploader/CustomFileUploader';
import { ImageFile } from '../../../../interfaces/salePost';
import EditImageManager from '../../../../components/EditImageManager/EditImageManager';


const DOORS_OPTIONS = [
  { value: "2", name: "2" },
  { value: "3", name: "3" },
  { value: "4", name: "4" },
  { value: "5", name: "5" },
  { value: "6", name: "6" },
];



const REGION_NAMES = [
  { id: 1, name: "Antofagasta" },
  { id: 2, name: "Arica y Parinacota" },
  { id: 3, name: "Atacama" },
  { id: 4, name: "Coquimbo" },
  { id: 5, name: "Región de Aisen del Gral. Carlos Ibañez del Campo" },
  { id: 6, name: "Región de la Araucania" },
  { id: 7, name: "Región de los lagos" },
  { id: 8, name: "Región de los rios" },
  { id: 9, name: "Región de Magallanes y de la Antartica Chilena" },
  { id: 10, name: "Región del Biobio" },
  { id: 11, name: "Región del libertador Gral. Bernardo O'Higgins" },
  { id: 12, name: "Región del Maule" },
  { id: 13, name: "Región Metropolitana de Santiago" },
  { id: 14, name: "Tarapaca" },
  { id: 15, name: "Valparaiso" }
];

const Edit = ({
  brands,
  getBrands,
  models,
  getModels,
  versions,
  getVersions,
  publication,
  getPublication,
  getArticlesFromPublication,
  setUploadImages,
  updateReducer,
  updatePublication,
  cleanAll,
  cleanUpdate,
  deletePublicationImage,
  postPublicationsImages,
  cleanImagesSaved,
  getMyPublicationsRequest,
  getYears,
  setIsNegotiate,
  getAdditionalCharacters,
  additionalCharacters,
  setAdditionalCharacters,
  opportunity
}: MyPublicationEditProps) => {

  const toast = useToast();
  const navigate = useNavigate();
  const params = useParams();

  const [isNegotiatePrice, setIsNegotiatePrice] = useState<YesNoTypes>("SI");
  const [negotiatePercentage, setNegotiatePercentage] = useState<string>("10");
  const [negotiatePercentageError, setNegotiatePercentageError] = useState<string>("");

  const [expanded, setExpanded] = useState<string | false>(false);
  const [completedSteps, setCompletedSteps] = useState<string[]>([]);
  const [timeOutMessage, setTimeOutMessage] = useState<any>({ open: false, text: "" });
  const [loading, setLoading] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openFeaturesModal, setOpenFeaturesModal] = useState<boolean>(false);
  const [selectedFeatureIds, setSelectedFeatureIds] = useState<string[]>([]);
  const [selectedAdditionalCharacters, setSelectedAdditionalCharactersState] = useState<any[]>([]);

  const [typeSelected, setTypeSelected] = useState<any>({ value: "", error: "" });
  const [brandSelected, setBrandSelected] = useState<any>({ value: "", error: "" });
  const [yearSelected, setYearSelected] = useState<any>({ value: "", error: "" });
  const [transmissionSelected, setTransmissionSelected] = useState<any>({ value: "", error: "" });
  const [doorsSelected, setDoorsSelected] = useState<any>({ value: "", error: "" });
  const [regionSelected, setRegionSelected] = useState<any>({ value: "", error: "" });
  const [selectedFeatures, setSelectedFeatures] = useState<string[]>([]);
  const [modelSelected, setModelSelected] = useState<any>({ value: "", error: "" });
  const [versionSelected, setVersionSelected] = useState<any>({ value: "", error: "" });
  const [colorSelected, setColorSelected] = useState<any>({ value: "", error: "" });
  const [fuelSelected, setFuelSelected] = useState<any>({ value: "", error: "" });
  const [mileage, setMileage] = useState<any>({ value: "", error: "" });
  const [accidentsReported, setAccidentsReported] = useState<any>({ value: "", error: "" });
  const [personalUse, setPersonalUse] = useState<any>({ value: "", error: "" });
  const [soleOwner, setSoleOwner] = useState<any>({ value: "", error: "" });
  const [isOpportunity, setIsOpportunity] = useState<boolean>(false);
  const [isIva, setIsIva] = useState<boolean>(false);

  const [tagsSelected, setTagsSelected] = useState<any[]>([]);
  const [newImages, setNewImages] = useState<any[]>([]);
  const [deleteImages, setDeleteImages] = useState<any[]>([]);
  const [imagesSelected, setImagesSelected] = useState<any[]>([]);
  const [confortsNormalized, setConfortsNormalized] = useState<any>();

  const [price, setPrice] = useState<any>({ value: "", error: "" });
  const REGION_OPTIONS = useMemo(() => {
    return REGION_NAMES.map(region => ({
      name: region.name,
      value: region.name,
      label: region.name,
    }));
  }, [REGION_NAMES]);

  const [hasRequiredImages, setHasRequiredImages] = useState<boolean>(false);

  const setImages = (imgs: ImageFile[] | ((prev: ImageFile[]) => ImageFile[])) => {
    if (typeof imgs === 'function') {
      setImagesSelected(prev => imgs(prev));
    } else {
      setImagesSelected(imgs);
    }
  };


  useEffect(() => {
    const selectedCodes = selectedAdditionalCharacters.flatMap((category: any) =>
      (category.value || []).filter((item: any) => item.value === true).map((item: any) => item.code)
    );
    setSelectedFeatureIds(selectedCodes);
  }, [selectedAdditionalCharacters]);


  useEffect(() => {

    getAdditionalCharacters();

  }, [getAdditionalCharacters]);


  const getFeatureName = (featureId: string): string => {

    if (Array.isArray(additionalCharacters)) {
      for (const category of additionalCharacters) {
        if (category && Array.isArray(category.value)) {
          const feature = category.value.find((item: any) => item.code === featureId);
          if (feature && feature.name) {
            return feature.name;
          }
        }
      }
    }

    if (Array.isArray(selectedAdditionalCharacters)) {
      for (const category of selectedAdditionalCharacters) {
        if (category && Array.isArray(category.value)) {
          const feature = category.value.find((item: any) => item.code === featureId);
          if (feature && feature.name) {
            return feature.name;
          }
        }
      }
    }

    return featureId;
  };


  const handleOpenFeaturesModal = () => {
    if (!additionalCharacters || additionalCharacters.length === 0) {

      getAdditionalCharacters();
    }

    const selectedCodes = Array.isArray(selectedAdditionalCharacters) ?
      selectedAdditionalCharacters.flatMap((category: any) =>
        (category?.value || []).filter((item: any) => item?.value === true).map((item: any) => item?.code)
      ) : [];
    setSelectedFeatureIds(selectedCodes);
    setOpenFeaturesModal(true);
  };

  useEffect(() => {
    if (publication?.data?.opportunity !== undefined) {
      setIsOpportunity(publication.data.opportunity === true);
    }
  }, [publication?.data?.opportunity]);

  useEffect(() => {
    if (publication?.data?.detail_edit?.iva !== undefined) {
      setIsIva(publication.data.detail_edit.iva === true);
    }
  }, [publication?.data?.detail_edit?.iva]);


  const handleSaveFeatures = () => {
    try {
      const selectedArray = [];
      if (Array.isArray(additionalCharacters) && additionalCharacters.length > 0) {

        for (const category of additionalCharacters) {
          if (category && Array.isArray(category.value)) {
            const selectedValues = category.value
              .filter((item: any) => item && item.code && selectedFeatureIds.includes(item.code))
              .map((item: any) => ({
                name: item.name || 'Característica',
                code: item.code,
                value: true,
              }));

            if (selectedValues.length > 0) {
              selectedArray.push({
                name: category.name || 'Categoría',
                code: category.code || `category-${Math.random().toString(36).substr(2, 9)}`,
                value: selectedValues,
              });
            }
          }
        }
      } else {
        console.warn('additionalCharacters no es un array válido:', additionalCharacters);
        getAdditionalCharacters();
      }

      if (selectedArray.length > 0) {
        setSelectedAdditionalCharactersState(selectedArray);
      }

      setOpenFeaturesModal(false);
    } catch (error) {
      console.error('Error al guardar características:', error);
      setOpenFeaturesModal(false);
    }
  };


  useEffect(() => {
    getAdditionalCharacters();
  }, []);

  useEffect(() => {
    if (Array.isArray(additionalCharacters)) {
      setAdditionalCharacters(additionalCharacters);
    }
  }, [additionalCharacters]);


  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleChangeImage = (event: any) => {

    const currentTotalImages = imagesSelected.length;
    const newFiles = Array.from(event.target.files);
    const MAX_IMAGES = 12;

    if (currentTotalImages >= MAX_IMAGES) {
      toast("Ya has alcanzado el límite máximo de 12 imágenes");
      return;
    }

    const availableSlots = MAX_IMAGES - currentTotalImages;
    const filesToAdd = newFiles.slice(0, availableSlots);

    if (filesToAdd.length < newFiles.length) {
      toast(`Solo puedes agregar ${availableSlots} imagen(es) más (Máximo ${MAX_IMAGES})`);
    }

    let images: any = [];
    filesToAdd.forEach((file: any, index: number) => {
      const image = {
        id: Math.floor((index + Math.random()) * 0x10000000000).toString(16),
        name: `${Math.floor((index + Math.random()) * 0x10000000000).toString(16)}.jpg`,
        path: URL.createObjectURL(file),
        file: file,
      };
      images = images.concat(image);
    });

    setNewImages(newImages.concat(images));
    setImagesSelected(imagesSelected.concat(images));
    setUploadImages(publication.update.newImages.data.concat(images));
  };

  const handleDeleteImage = (value: any) => {

    const imageId = typeof value === 'object' ? value.id : value;

    if (!imageId) {
      console.error('No se pudo identificar la imagen a eliminar');
      return;
    }

    const newImageFound = newImages.some((item: any) => item?.id === imageId);
    const filteredImages = imagesSelected.filter((item: any) => item?.id !== imageId);

    setImagesSelected(filteredImages);

    const uploadImages = publication.update.newImages.data.filter((item: any) => item?.id !== imageId);
    setUploadImages(uploadImages);

    if (!newImageFound) {

      const deleteImage = imagesSelected.find((item: any) => item?.id === imageId);
      if (deleteImage) {
        setDeleteImages([...deleteImages, deleteImage]);
      }
    } else {

      const filterNewImages = newImages.filter((item: any) => item?.id !== imageId);
      setNewImages(filterNewImages);
    }
  };

  const onChangePosition = (pictures: any) => {
    setImagesSelected(pictures);
  };


  const handlePressPrice = (value: any) => {
    const { formattedNumber } = formatInput(value);
    setPrice({ ...price, value: formattedNumber });
  }

  const handlePressMileage = (value: any) => {
    const { formattedNumber } = formatInput(value);
    setMileage({ ...mileage, value: formattedNumber });
  }

  const handleChangeDoors = (id: string) => {
    setDoorsSelected({ value: id, error: "" });
  }

  const handleChangeColor = (id: string) => {
    setColorSelected({ ...colorSelected, value: id });
  }

  const handleChangeFuel = (id: string) => {
    setFuelSelected({ ...fuelSelected, value: id });
  }

  const handleChangeModel = (id: string) => {
    const model = modelsNormalized.find((item: any) => item?.id === id);
    setModelSelected({ value: { id: model?.id, name: model?.name }, error: "" });
    setVersionSelected({ value: "", error: "" });

    if (model?.id && yearSelected?.value) {
      getVersions?.({ model_id: model.id, year: yearSelected.value });
    }
  };



  const handleChangeVersion = (id: string) => {
    const version = versionsNormalized.find((item: any) => item?.id === id);
    setVersionSelected({ value: { id: version?.id, name: version?.name }, error: "" });
  }

  const handleChangeType = (value: string) => {
    setTypeSelected({ value, error: "" });
  };


  const handleChangeYear = (yearValue: string) => {
    const yearInt = parseInt(yearValue);
    setYearSelected({ value: yearInt, error: "" });
    setVersionSelected({ value: "", error: "" });

    if (modelSelected?.value?.id) {
      getVersions?.({
        model_id: modelSelected.value.id,
        year: yearInt,
      });
    }
  };


  const handleChangeBrand = (selected: any) => {
    const id = selected?.id ?? selected;
    const brand = brandsNormalized.find((item: any) => item?.id === id);
    if (brand) {
      setBrandSelected({ value: { id: brand.id, name: brand.name }, error: "" });
      setModelSelected({ value: "", error: "" });
      setVersionSelected({ value: "", error: "" });

      getModels?.(brand.id);
    }
  };


  const handleChangeTransmission = (value: string) => {
    setTransmissionSelected({ value, error: "" });
  };


  const onChangeAccidentsReported = (value: any) => {
    setAccidentsReported({ ...accidentsReported, value: value });
  }
  const onChangeRegion = (event: any) => {
    setRegionSelected({ value: event, error: "" });
  };


  const onChangePersonalUse = (value: any) => {
    setPersonalUse({ ...personalUse, value: value });
  }

  const onChangeSoleOwner = (value: any) => {
    setSoleOwner({ ...soleOwner, value: value });
  }

  const updateDataPublication = () => {

    const orderedImages = imagesSelected
      .filter(img => !img.toDelete && img.upload === "success")
      .sort((a, b) => (a.index || 0) - (b.index || 0))
      .map((image: any) => ({
        ...image,
        id: image.id,
        path: image.previewURL || image.path
      }));


    const vehicle: VehiclePost = {
      type: typeSelected?.value,
      transmission: transmissionSelected?.value,
      doors: doorsSelected?.value,
      brand: brandSelected?.value?.name,
      brand_id: brandSelected?.value?.id,
      model: modelSelected?.value?.name,
      model_id: modelSelected?.value?.id,
      version: versionSelected?.value?.name,
      version_id: versionSelected?.value?.id,
      year: yearSelected?.value,
      mileage: publication?.data?.condition === "new" ? 0 : parseInt(removePointsInText(mileage?.value)),
      color: colorSelected?.value,
      plate: publication?.articles?.data?.plate,
      price: parseInt(removePointsInText(price?.value)),
      pick_up_price: publication?.data?.other_prices?.pick_up_price?.toString() === "0" ? parseInt(removePointsInText(price?.value)) : publication?.data?.other_prices?.pick_up_price,
      sale_price: publication?.data?.other_prices?.sale_price?.toString() === "0" ? parseInt(removePointsInText(price?.value)) : publication?.data?.other_prices?.sale_price,
      confort: confortsNormalized,
      vehicle_paid: publication?.articles?.data?.vehicle_paid,
      fuel: fuelSelected?.value,
      additional_characters: selectedAdditionalCharacters



    }

    const publicationObject = {
      article: vehicle,
      country: publication?.data?.country,
      region: regionSelected?.value,
      pictures: orderedImages,
      tags: tagsSelected,
      record: publication?.data?.condition === "new" ? {
        accidents_reported: "false",
        personal_use: "false",
        sole_owner: "true"
      } : {
        accidents_reported: accidentsReported?.value,
        personal_use: personalUse?.value,
        sole_owner: soleOwner?.value
      },
      detail: {
        negotiate: isNegotiatePrice === "SI",
        bonus_info: { bonus: undefined, value: undefined },
        negotiate_percent: parseInt(negotiatePercentage),
        iva: isIva
      },
      opportunity: isOpportunity,



    }

    updatePublication(publicationObject);
  }

  const handleSave = () => {
    let hasError = false;
    let firstErrorPanel: string | null = null;
    if (isNegotiatePrice === "SI" && (!negotiatePercentage || parseInt(negotiatePercentage) <= 0)) {
      setNegotiatePercentageError("Ingrese un porcentaje válido (1-100%)");
      hasError = true;
      firstErrorPanel ||= "panel3";
    }

    if (!typeSelected?.value) {
      setTypeSelected({ ...typeSelected, error: "Debes seleccionar una carrocería" });
      hasError = true;
      firstErrorPanel ||= "panel1";
    }
    if (!brandSelected?.value?.id && !brandSelected?.value?.name) {
      setBrandSelected({ ...brandSelected, error: "Debes seleccionar una marca" });
      hasError = true;
      firstErrorPanel ||= "panel1";
    }
    if (!yearSelected?.value) {
      setYearSelected({ ...yearSelected, error: "Debes seleccionar un año" });
      hasError = true;
      firstErrorPanel ||= "panel1";
    }
    if (!modelSelected?.value?.id && !modelSelected?.value?.name) {
      setModelSelected({ ...modelSelected, error: "Debes seleccionar un modelo" });
      hasError = true;
      firstErrorPanel ||= "panel1";
    }
    if (!versionSelected?.value?.id && !versionSelected?.value?.name) {
      setVersionSelected({ ...versionSelected, error: "Debes seleccionar una versión" });
      hasError = true;
      firstErrorPanel ||= "panel1";
    }
    if (!colorSelected?.value) {
      setColorSelected({ ...colorSelected, error: "Debes seleccionar un color" });
      hasError = true;
      firstErrorPanel ||= "panel1";
    }
    if (!fuelSelected?.value) {
      setFuelSelected({ ...fuelSelected, error: "Debes seleccionar un combustible" });
      hasError = true;
      firstErrorPanel ||= "panel1";
    }
    if (!transmissionSelected?.value) {
      setTransmissionSelected({ ...transmissionSelected, error: "Debes seleccionar una transmisión" });
      hasError = true;
      firstErrorPanel ||= "panel1";
    }
    if (!doorsSelected?.value) {
      setDoorsSelected({ ...doorsSelected, error: "Debes seleccionar cantidad de puertas" });
      hasError = true;
      firstErrorPanel ||= "panel1";
    }
    if (!regionSelected?.value) {
      setRegionSelected({ ...regionSelected, error: "Debes seleccionar una región" });
      hasError = true;
      firstErrorPanel ||= "panel1";
    }

    if (publication?.data?.condition !== "new") {
      if (!mileage?.value) {
        setMileage({ ...mileage, error: "Debes ingresar el kilometraje" });
        hasError = true;
        firstErrorPanel ||= "panel1";
      } else if (parseInt(removePointsInText(mileage.value)) === 0) {
        setMileage({ ...mileage, error: "No se puede publicar vehículos 0km" });
        hasError = true;
        firstErrorPanel ||= "panel1";
      }
    }



    if (!hasRequiredImages) {

      const requiredIndices = [0, 1, 2, 3, 4];
      const requiredLabels = ["frente (portada)", "atrás", "lateral izquierdo", "lateral derecho", "interior"];
      const activeImages = imagesSelected.filter(img => !img.toDelete && img.upload === "success");

      const missingIndices = requiredIndices.filter(index =>
        !activeImages.some(img => typeof img.index === 'number' && img.index === index)
      );
      const missingLabels = missingIndices.map(index => requiredLabels[index]);

      if (missingLabels.length > 0) {
        toast(`Faltan las siguientes fotos obligatorias: ${missingLabels.join(', ')}`);
      } else {
        toast("Debes subir las 5 fotos obligatorias (frente, atrás, laterales e interior)");
      }

      hasError = true;
      firstErrorPanel ||= "panel2";
    }

    if (!price?.value) {
      setPrice({ ...price, error: "Debes ingresar un precio" });
      hasError = true;
      firstErrorPanel ||= "panel3";
    } else if (parseInt(removePointsInText(price.value)) === 0) {
      setPrice({ ...price, error: "El precio no puede ser $0" });
      hasError = true;
      firstErrorPanel ||= "panel3";
    }

    if (hasError) {
      if (firstErrorPanel) setExpanded(firstErrorPanel);
      return;
    }

    setLoading(true);
    setTimeOutMessage({ open: true, text: `Guardando` });


    updateDataPublication();
  };

  const modelsNormalized: any = useMemo(() => {
    const normalized = models?.data && models?.data.map((model: any) => ({
      id: model?.model_id,
      name: model?.name
    })) || [];
    
    // Agregar opción temporal si name pero no existe en el array
    if (modelSelected?.value?.id === undefined && modelSelected?.value?.name) {
      const exists = normalized.some((m: any) => 
        m.name?.toLowerCase() === modelSelected.value.name.toLowerCase()
      );
      if (!exists) {
        return [{ id: modelSelected.value.name, name: modelSelected.value.name }, ...normalized];
      }
    }
    
    return normalized;
  }, [models?.data, modelSelected?.value?.id, modelSelected?.value?.name]);



  const typesNormalized: any = useMemo(() => {
    const normalized = TYPE_TYPES && TYPE_TYPES.map((type: any) => (
      {
        id: type?.id,
        name: type?.value,
        value: type?.value
      }
    )) || [];
    
    // Agregar opción temporal si el valor no existe en el array (comparación case-insensitive y trim)
    if (typeSelected?.value) {
      const normalizeString = (str: string) => str?.toLowerCase().trim().replace(/\s+/g, ' ');
      const normalizedSelectedValue = normalizeString(typeSelected.value);
      
      const exists = normalized.some((t: any) => {
        const normalizedOptionValue = normalizeString(t.value);
        return normalizedOptionValue === normalizedSelectedValue;
      });
      
      if (!exists) {
        return [{ 
          id: typeSelected.value, 
          name: typeSelected.value, 
          value: typeSelected.value 
        }, ...normalized];
      }
    }
    
    return normalized;
  }, [TYPE_TYPES, typeSelected?.value]);

  const versionsNormalized: any = useMemo(() => {
    const normalized = versions?.data?.map((version: any) => ({
      id: version?.version_id,
      name: version?.name,
    })) || [];
    
    // Agregar opción temporal si tiene name pero no existe en el array
    if (versionSelected?.value?.id === undefined && versionSelected?.value?.name) {
      const exists = normalized.some((v: any) => 
        v.name?.toLowerCase() === versionSelected.value.name.toLowerCase()
      );
      if (!exists) {
        return [{ id: versionSelected.value.name, name: versionSelected.value.name }, ...normalized, { id: -1, name: "OTRA" }];
      }
    }
    
    return [...normalized, { id: -1, name: "OTRA" }];
  }, [versions?.data, versionSelected?.value?.id, versionSelected?.value?.name]);

  const brandsNormalized: any = useMemo(() => {
    const normalized = brands?.data && brands?.data.map((brand: any) => ({
      id: brand?.brand_id,
      name: brand?.name
    })) || [];
    
    // Agregar opción temporal si name pero no existe en el array
    if (brandSelected?.value?.id === undefined && brandSelected?.value?.name) {
      const exists = normalized.some((b: any) => 
        b.name?.toLowerCase() === brandSelected.value.name.toLowerCase()
      );
      if (!exists) {
        return [{ id: brandSelected.value.name, name: brandSelected.value.name }, ...normalized];
      }
    }
    
    return normalized;
  }, [brands?.data, brandSelected?.value?.id, brandSelected?.value?.name]);
  
  const buildYears = (range = 13) => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: range }, (_, i) => currentYear - i);
  };

  const yearsNormalized = useMemo(() => {
    return buildYears(13).map((year) => ({
      id: year,
      name: year.toString(),
    }));
  }, []);

  const colorsNormalized: any = useMemo(() => {
    return COLORS && COLORS.map((color: any) => (
      {
        id: color,
        name: capitalize(color)
      }
    ))
  }, [COLORS]);

  const transmissionsNormalized: any = useMemo(() => {
    return TRANSMISSION_TYPES && TRANSMISSION_TYPES.map((transmission: any, index: number) => ({
      id: index,
      name: transmission,
      value: transmission
    })) || [];
  }, [TRANSMISSION_TYPES]);

  const fuelsNormalized: any = useMemo(() => {
    return FUEL_TYPES && FUEL_TYPES.map((fuel: any) => (
      {
        id: fuel,
        name: capitalize(fuel)
      }
    ))
  }, [FUEL_TYPES]);

  const numberOfInvalidPictures = useMemo(() => {
    const count = {
      invalid: 0,
      total: 0
    };
    if (imagesSelected && imagesSelected.length) {
      imagesSelected.forEach((picture: any) => {
        if (picture.valid === false) count.invalid++;
      })
      count.total = imagesSelected.length;
    }
    return count;
  }, [imagesSelected])

  useEffect(() => {
    if (publication?.articles?.fetching === "success" && colorsNormalized.length > 0) {
      const colorFound = colorsNormalized.find((item: any) => item?.id === publication?.articles?.data?.color.toLowerCase());
      setColorSelected({ value: colorFound?.id, error: "" });
    }
  }, [colorsNormalized, publication?.articles?.fetching]);

  useEffect(() => {
    if (
      publication?.articles?.fetching === "success" &&
      !typeSelected?.value &&
      typesNormalized.length > 0 &&
      publication?.articles?.data?.type
    ) {
      const normalizeString = (str: string) => str?.toLowerCase().trim().replace(/\s+/g, ' ');
      const typeFromAPI = publication.articles.data.type;
      
      const typeFound = typesNormalized.find((item: any) => 
        normalizeString(item?.value) === normalizeString(typeFromAPI)
      );
      
      if (typeFound) {
        setTypeSelected({ value: typeFound.value, error: "" });
      } else {
        setTypeSelected({ value: typeFromAPI, error: "" });
      }
    }
  }, [typesNormalized, publication?.articles?.fetching, publication?.articles?.data?.type, typeSelected?.value]);

  useEffect(() => {

    const activeImages = imagesSelected.filter(img => !img.toDelete && img.upload === "success");
    if (activeImages.length < 3) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [imagesSelected]);

  useEffect(() => {

    if (publication?.articles?.fetching === "success") {
      if (publication?.articles?.data?.brand_id) {
        getModels(publication?.articles?.data?.brand_id.toString());
      }
      getBrands();
      getVersions({
        model_id: publication?.articles?.data?.model_id,
        year: publication?.articles?.data?.year
      });
      setBrandSelected({ value: { id: publication?.articles?.data?.brand_id, name: publication?.articles?.data?.brand }, error: "" });
      // setTypeSelected({ value: publication?.articles?.data?.type, error: "" }); // Comentado: ahora se normaliza en el useEffect específico
      setYearSelected({ value: publication?.articles?.data?.year, error: "" });
      setTransmissionSelected({ value: publication?.articles?.data?.transmission, error: "" });
      setPrice({ ...price, value: publication?.articles?.data && addPointsInText(publication?.articles?.data?.price), error: "" });
      setMileage({ value: publication?.articles?.data && addPointsInText(parseInt(publication?.articles?.data?.secondary_description)), error: "" });
      setModelSelected({ value: { id: publication?.articles?.data?.model_id, name: publication?.articles?.data?.model }, error: "" });
      setVersionSelected({ value: { id: publication?.articles?.data?.version_id, name: publication?.articles?.data?.version }, error: "" });
      setFuelSelected({ value: publication?.articles?.data?.fuel.toLowerCase(), error: "" });
      setDoorsSelected({ value: publication?.articles?.data?.doors?.toString(), error: "" });
      setConfortsNormalized(publication?.articles?.data?.additional_characters);

      if (publication?.articles?.data?.additional_characters &&
        Array.isArray(publication?.articles?.data?.additional_characters) &&
        publication?.articles?.data?.additional_characters.length > 0) {

        setSelectedAdditionalCharactersState(publication?.articles?.data?.additional_characters);
      }

      setIsNegotiatePrice(publication?.data?.detail_edit?.negotiate ? "SI" : "NO");
      setNegotiatePercentage(publication?.data?.detail_edit?.negotiate_percent || "0");
    }
  }, [publication?.articles?.fetching]);

  useEffect(() => {

    if (publication?.fetching === "success") {
      setTagsSelected(publication?.data?.tags);
      setImagesSelected(publication?.data?.pictures);
      setRegionSelected({ value: publication?.data?.region, error: "" });
      setPrice({ value: addPointsInText(publication?.data?.price), error: "" });
      setMileage({ value: addPointsInText(publication?.data?.secondary_description), error: "" });
      setAccidentsReported({ ...accidentsReported, value: publication?.data?.record_edit?.accidents_reported });
      setPersonalUse({ ...personalUse, value: publication?.data?.record_edit?.personal_use });
      setSoleOwner({ ...soleOwner, value: publication?.data?.record_edit?.sole_owner });
      setIsNegotiatePrice(publication?.data?.detail_edit?.negotiate ? "SI" : "NO");
      setNegotiatePercentage(
        publication?.data?.detail_edit?.negotiate_percent !== undefined && publication?.data?.detail_edit?.negotiate_percent !== null
          ? publication.data.detail_edit.negotiate_percent.toString()
          : "0"
      );
      setSelectedAdditionalCharactersState(publication?.articles?.data?.additional_characters || []);
    }
  }, [publication?.fetching]);

  useEffect(() => {
    if (updateReducer?.newImages?.fetching === "failure") {
      if (updateReducer?.newImages.data.length) {
        updateReducer?.newImages.data.forEach((newImage: any) => {
          if (newImage.error) {
            setNewImages(prev => {
              return prev.map((prevImage) => {
                if (prevImage.name === newImage.name) {
                  return {
                    ...prevImage,
                    error: true
                  }
                }
                return prevImage
              })
            });
            setImagesSelected(prev => {
              return prev.map((prevImage) => {
                if (prevImage.name === newImage.name) {
                  return {
                    ...prevImage,
                    error: true
                  }
                }
                return prevImage
              })
            });
          }
        })
      }
      toast("Error al subir nuevas imagenes");
      setLoading(false);
      setTimeOutMessage({ ...timeOutMessage, open: false });
      return;
    }
    if (updateReducer?.newImages?.fetching === "success" && updateReducer?.newImages?.count === updateReducer?.newImages?.data.length && !updateReducer?.newImages?.reloaded && updateReducer?.deleteImages?.data.length === 0) {
      updateDataPublication();
    }
    if (updateReducer?.newImages?.fetching === "success" && updateReducer?.newImages?.reloaded) {
      updateReducer?.newImages.data.find((newImage: any) => {
        if (newImage.name === updateReducer?.newImages?.reloadedName) {
          setNewImages(prev => {
            return prev.filter((prevImage) => {
              if (prevImage.name === newImage.name) return false;
              return true;
            })
          });
          setImagesSelected(prev => {
            return prev.map((prevImage) => {
              if (prevImage.name === newImage.name) {
                return {
                  ...prevImage,
                  error: false
                }
              }
              return prevImage
            })
          });
          return true;
        }
        return false;
      })
    }
  }, [updateReducer?.newImages]);

  useEffect(() => {
    if (updateReducer?.deleteImages?.fetching === "failure") {
      toast("Error al eliminar imagenes");
    }
    if (updateReducer?.deleteImages?.fetching === "success" && deleteImages.length === updateReducer?.deleteImages?.data.length) {
      setDeleteImages([]);
    }
    if (updateReducer?.deleteImages?.fetching === "success" && deleteImages.length === updateReducer?.deleteImages?.data.length && newImages.length === 0 && !updateReducer?.newImages?.reloaded) {
      updateDataPublication();
    }
  }, [updateReducer?.deleteImages]);

  useEffect(() => {
    if (updateReducer?.newImages?.count === updateReducer?.newImages?.data.length && deleteImages.length === 0 && updateReducer?.deleteImages?.fetching === "success" && updateReducer?.newImages?.fetching === "success" && !updateReducer?.newImages?.reloaded) {
      updateDataPublication();
    }
  }, [updateReducer?.newImages, deleteImages]);

  useEffect(() => {
    if (updateReducer?.fetching === "failure") {
      if (updateReducer?.error?.code === "PUBLICATION_IN_TRANSACTION") {
        toast("Error: La publicación está en transacción");
      } else {
        toast("Ha ocurrido un error");
      }
      setLoading(false);
      setTimeOutMessage({ ...timeOutMessage, open: false });
      cleanUpdate();
    }
    if (updateReducer?.fetching === "success") {
      toast("Publicación actualizada correctamente");
      setLoading(false);
      setTimeOutMessage({ ...timeOutMessage, open: false });
      cleanAll();
      getMyPublicationsRequest(1);
      return navigate(`/profile/my_publications/${params?.id}/detail`);
    }
  }, [updateReducer?.fetching]);

  useEffect(() => {
    getPublication(params?.id);
    getArticlesFromPublication(params?.id);
    cleanImagesSaved();
  }, []);


  useEffect(() => {
    if (publication?.data?.pictures?.length) {
      const normalizedPictures = publication.data.pictures.map((picture: any, idx: number) => ({
        ...picture,
        previewURL: picture?.path || picture?.url || picture?.uri || "",
        index: idx,
        upload: "success",
        protected: idx < 5
      }));

      setImagesSelected(normalizedPictures);
    }
  }, [publication?.data?.pictures]);

  const handleRemoveFeature = (featureId: string) => {
    try {
      const updated = selectedAdditionalCharacters.map((cat: any) => ({
        ...cat,
        value: cat.value.filter((item: any) => item.code !== featureId)
      })).filter((cat: any) => cat.value.length > 0);

      setSelectedAdditionalCharactersState(updated);
    } catch (error) {
      console.error('Error al eliminar la característica:', error);
    }
  };

  const transmissionValueForSelect = useMemo(() => {
    if (!transmissionSelected?.value) return '';
    
    const value = transmissionSelected.value.toLowerCase();
    
    if (value.includes('manual') || value === 'mt' || value === 'm') {
      const manual = transmissionsNormalized?.find((t: any) => 
        t.value?.toLowerCase().includes('manual')
      );
      return manual?.value || transmissionSelected.value;
    }
    
    if (value.includes('auto') || value.includes('at') || value === 'a') {
      const auto = transmissionsNormalized?.find((t: any) => 
        t.value?.toLowerCase().includes('auto')
      );
      return auto?.value || transmissionSelected.value;
    }
    
    return transmissionSelected.value;
  }, [transmissionSelected?.value, transmissionsNormalized]);

  const brandValueForSelect = useMemo(() => {
    if (brandSelected?.value?.id !== undefined) {
      return brandSelected.value.id;
    }
    
    if (brandSelected?.value?.name && brandsNormalized) {
      const found = brandsNormalized.find((b: any) => 
        b.name?.toLowerCase() === brandSelected.value.name.toLowerCase()
      );
      if (found) {
        return found.id;
      }
    }
    
    return brandSelected?.value?.name;
  }, [brandSelected?.value?.id, brandSelected?.value?.name, brandsNormalized]);

  const modelValueForSelect = useMemo(() => {
    if (modelSelected?.value?.id !== undefined) {
      return modelSelected.value.id;
    }
    
    if (modelSelected?.value?.name && modelsNormalized) {
      const found = modelsNormalized.find((m: any) => 
        m.name?.toLowerCase() === modelSelected.value.name.toLowerCase()
      );
      if (found) {
        return found.id;
      }
    }
    
    return modelSelected?.value?.name;
  }, [modelSelected?.value?.id, modelSelected?.value?.name, modelsNormalized]);

  const versionValueForSelect = useMemo(() => {
    if (versionSelected?.value?.id !== undefined) {
      return versionSelected.value.id;
    }
    
    if (versionSelected?.value?.name && versionsNormalized) {
      const found = versionsNormalized.find((v: any) => 
        v.name?.toLowerCase() === versionSelected.value.name.toLowerCase()
      );
      if (found) {
        return found.id;
      }
    }
    
    return versionSelected?.value?.name;
  }, [versionSelected?.value?.id, versionSelected?.value?.name, versionsNormalized]);

  return (

    <div className={styles.edit}>
      <ProfileCard breadCrumbs={myPubEditBreadCrumb(params?.id, publication?.data?.title)}>
        <h2 className={styles.pageTitle}>Editar vehículo</h2>

        <div className={styles.accordionContainer}>
          {/* PANEL 1: INFORMACIÓN BÁSICA */}
          <Accordion
            expanded={expanded === 'panel1'}
            onChange={handleChange('panel1')}
            className={`${styles.accordion} ${publication?.data?.condition === "new" ? styles.accordionCompact : ""}`}
          >
            <AccordionSummary
              expandIcon={<span style={{ color: '#7100FF', fontSize: '15px', marginRight: '10px' }}>
                {expanded === 'panel1' ? <span style={{ color: '#484848', fontSize: '18px' }}>1/3</span> : 'Editar'}
              </span>}
              className={styles.accordionSummary}
            >
              <div className={styles.stepHeader}>
                {expanded !== 'panel1' && (
                  <span className={styles.stepNumber}>
                    Paso 1
                  </span>
                )}
                <h3>Información básica</h3>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className={styles.content}>
                {/* DATOS DEL VEHÍCULO */}
                <div className={`${styles.item} ${styles.information}`}>
                  {publication?.fetching === "loading" ? (
                    <div className={styles.skeletonItems}></div>
                  ) : (
                    <>
                      <div className={styles.basicInfoContainer}>
                        <div className={styles.formSection}>
                          <div className={styles.formGrid}>
                            <SelectShared
                              label="Carrocería"
                              name="type"
                              value={typeSelected?.value}
                              onChange={handleChangeType}
                              loading={publication?.fetching === "loading"}
                              options={typesNormalized}
                              error={typeSelected?.error}
                              keyValue="value"
                            />

                            <SelectShared
                              label="Año"
                              name="year"
                              value={yearSelected?.value}
                              onChange={handleChangeYear}
                              loading={(publication?.fetching === "loading")}
                              options={yearsNormalized}
                              error={yearSelected?.error}
                            />
                            <SelectShared
                              label="Marca"
                              name="brand"
                              value={brandValueForSelect}
                              onChange={handleChangeBrand}
                              loading={publication?.fetching === "loading"}
                              options={brandsNormalized}
                              error={brandSelected?.error}
                              keyValue="id"
                              disabled
                            />

                            <SelectShared
                              className={styles.fullWidth}
                              label="Modelo"
                              name="model"
                              value={modelValueForSelect}
                              onChange={handleChangeModel}
                              loading={(publication?.fetching === "loading")}
                              options={modelsNormalized}
                              error={modelSelected?.error}
                              disabled
                            />
                            <SelectShared
                              className={styles.fullWidth}
                              label="Versión"
                              name="version"
                              value={versionValueForSelect}
                              onChange={handleChangeVersion}
                              loading={(publication?.fetching === "loading")}
                              options={versionsNormalized}
                              error={versionSelected?.error}
                            />

                            <SelectShared
                              label="Color"
                              name="color"
                              value={colorSelected?.value}
                              onChange={handleChangeColor}
                              loading={(publication?.fetching === "loading")}
                              options={colorsNormalized}
                              error={colorSelected?.error}
                            />
                            <SelectShared
                              label="Transmisión"
                              name="transmission"
                              value={transmissionValueForSelect}
                              onChange={handleChangeTransmission}
                              loading={publication?.fetching === "loading"}
                              options={transmissionsNormalized}
                              error={transmissionSelected?.error}
                              keyValue="value"
                            />



                            <SelectShared
                              label="Combustible"
                              name="fuel"
                              value={fuelSelected?.value}
                              onChange={handleChangeFuel}
                              loading={(publication?.fetching === "loading")}
                              options={fuelsNormalized}
                              error={fuelSelected?.error}
                            />

                          </div>
                          <div className={styles.twoColumnGrid}>
                            {publication?.data?.condition !== "new" ? (
                              <TextFieldShared
                                label="Kilometraje"
                                name="mileage"
                                value={mileage?.value}
                                onChange={handlePressMileage}
                                error={mileage?.error}
                                loading={(publication?.fetching === "loading")}
                              />
                            ) : (
                              <SelectShared
                                label="Region"
                                name="region"
                                value={regionSelected?.value}
                                onChange={onChangeRegion}
                                options={REGION_OPTIONS}
                                className={styles.input}
                                keyValue="name"
                                error={regionSelected?.error}
                              />
                            )}
                            <SelectShared
                              label="Puertas"
                              name="doors"
                              value={doorsSelected?.value}
                              onChange={handleChangeDoors}
                              loading={(publication?.fetching === "loading")}
                              options={DOORS_OPTIONS}
                              error={doorsSelected?.error}
                              keyValue="value"
                            />
                          </div>
                          {publication?.data?.condition !== "new" && (
                            <>
                              <p>Datos complementarios</p>
                              <div className={styles.twoColumnGrid}>
                                <SelectShared
                                  label="Uso del vehículo"
                                  name="personalUse"
                                  value={personalUse?.value}
                                  onChange={onChangePersonalUse}
                                  options={optionsPersonalUse}
                                  className={styles.input}
                                  keyValue="value"
                                />
                                <SelectShared
                                  label="Unico dueño"
                                  name="soleOwner"
                                  value={soleOwner?.value}
                                  onChange={onChangeSoleOwner}
                                  options={optionsSoleOwner}
                                  className={styles.input}
                                  keyValue="value"
                                />
                              </div>
                              <div className={styles.twoColumnGrid}>
                                <SelectShared
                                  label="Accidentes reportados"
                                  name="accidentsReported"
                                  value={accidentsReported?.value}
                                  onChange={onChangeAccidentsReported}
                                  options={optionsAccidentsReported}
                                  className={styles.input}
                                  keyValue="value"
                                />
                                <SelectShared
                                  label="Region"
                                  name="region"
                                  value={regionSelected?.value}
                                  onChange={onChangeRegion}
                                  options={REGION_OPTIONS}
                                  className={styles.input}
                                  keyValue="name"
                                  error={regionSelected?.error}
                                />
                              </div>
                            </>
                          )}
                          <div className={styles.additionalFeaturesWrapper}>
                            <div className={styles.addFeaturesHeader}>
                              <Typography variant="subtitle1" sx={{ fontFamily: 'LTSaeada, Roboto, sans-serif' }}>Características adicionales</Typography>
                              <button
                                className={styles.addFeaturesButton}
                                onClick={handleOpenFeaturesModal}
                              >
                                <AddIcon className={styles.addIcon} />
                                Añadir características
                              </button>
                            </div>

                            <div className={styles.featuresList}>
                              {selectedFeatureIds.map((featureId) => (

                                <Chip
                                  key={featureId}
                                  label={getFeatureName(featureId)}
                                  onDelete={() => handleRemoveFeature(featureId)}
                                  className={styles.featureChip}
                                  deleteIcon={<CloseIcon style={{ fontSize: '16px' }} />}
                                  sx={{
                                    margin: '0 4px 4px 0',
                                    height: '28px',
                                    color: 'rgb(115, 115, 115)'
                                    ,
                                  }}
                                />
                              ))}
                            </div>
                          </div>

                        </div>
                        <div className={`${styles.imageSection} ${publication?.data?.condition === "new" ? styles.imageSectionCompact : ""}`}>
                          <img src={require('../../../../assets/images/linze-car.png')} alt="Linze Keys" />
                          <div className={styles.buttonContainer}>

                          </div>
                        </div>
                      </div>

                    </>
                  )}
                </div>
              </div>
            </AccordionDetails>
          </Accordion>

          {/* PANEL 2: FOTOS Y VIDEOS */}
          <Accordion
            expanded={expanded === 'panel2'}
            onChange={handleChange('panel2')}
            className={styles.accordion}
          >
            <AccordionSummary
              expandIcon={<span style={{ color: '#7100FF', fontSize: '15px', marginRight: '10px' }}>
                {expanded === 'panel2' ? <span style={{ color: '#484848', fontSize: '18px' }}>2/3</span> : 'Editar'}
              </span>}
              className={styles.accordionSummary}
            >
              <div className={styles.stepHeader}>
                {expanded !== 'panel2' && (
                  <span className={styles.stepNumber}>

                    Paso 2
                  </span>
                )}
                <h3>Fotos y videos</h3>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <EditImageManager
                imagesSelected={imagesSelected}
                setImages={setImages}
                postPublicationsImages={postPublicationsImages}
                deletePublicationImage={deletePublicationImage}
                fetchingDeleteImage={updateReducer?.deleteImages?.fetching}
                onValidityChange={setHasRequiredImages}
              />
            </AccordionDetails>
          </Accordion>

          {/* PANEL 3: PRECIO Y NEGOCIACIÓN */}
          <Accordion
            expanded={expanded === 'panel3'}
            onChange={handleChange('panel3')}
            className={styles.accordion}
          >
            <AccordionSummary
              expandIcon={<span style={{ color: '#7100FF', fontSize: '15px', marginRight: '10px' }}>
                {expanded === 'panel3' ? <span style={{ color: '#484848', fontSize: '18px' }}>3/3</span> : 'Editar'}
              </span>}
              className={styles.accordionSummary}
            >
              <div className={styles.stepHeader}>
                {expanded !== 'panel3' && (
                  <span className={styles.stepNumber}>

                    Paso 3
                  </span>
                )}
                <h3>Precio y negociación</h3>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className={styles.priceSection}>
                <div className={styles.priceContainer}>
                  <div className={styles.priceInput}>
                    <label>Ingresa el precio de venta</label>
                    <div>
                      <TextFieldShared
                        label="Precio"
                        name="price"
                        value={price?.value}
                        onChange={handlePressPrice}
                        loading={(publication?.fetching === "loading")}
                      />
                    </div>
                    {price.error && <p className={styles.errorMessage}>{price.error}</p>}
                  </div>

                  <div className={styles.checkboxGroup}>
                    {publication?.data?.condition === "new" &&
                      <label className={styles.checkboxLabel}>
                        <input
                          type="checkbox"
                          checked={isIva}
                          onChange={(e) => setIsIva(e.target.checked)}
                        />
                        <span className={styles.checkboxOpportunityLabel}> Incluir +IVA</span>
                      </label>
                    }
                  </div>

                  <div className={styles.negotiationSection}>
                    <h3>¿Estás dispuesto a negociar?</h3>
                    <div className={styles.radioGroup}>
                      <label className={styles.radioLabel}>
                        <input
                          type="radio"
                          name="negotiable"
                          checked={isNegotiatePrice === "SI"}
                          onChange={() => {
                            setIsNegotiatePrice("SI");
                          }}
                        />
                        <span>Sí</span>
                      </label>
                      <label className={styles.radioLabel}>
                        <input
                          type="radio"
                          name="negotiable"
                          checked={isNegotiatePrice === "NO"}
                          onChange={() => {
                            setIsNegotiatePrice("NO");
                          }}
                        />
                        <span>No</span>
                      </label>
                    </div>

                    {isNegotiatePrice === "SI" && (
                      <div className={styles.percentageInput}>
                        <label>Porcentaje de negociación (%)</label>
                        <div className={styles.inputWithSymbol}>
                          <input
                            type="number"
                            min="0"
                            max="100"
                            value={negotiatePercentage}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "" || (parseInt(value) >= 0 && parseInt(value) <= 100)) {
                                setNegotiatePercentage(value);
                                setNegotiatePercentageError("");

                              }
                            }}
                            onBlur={() => {
                              if (isNegotiatePrice === "SI" && (!negotiatePercentage || parseInt(negotiatePercentage) === 0)) {
                                setNegotiatePercentageError("Ingrese un porcentaje válido (1-100%)");
                              }
                            }}
                          />
                          <span className={styles.percentSymbol}>%</span>
                        </div>
                        {negotiatePercentageError && (
                          <p className={styles.errorMessage}>{negotiatePercentageError}</p>
                        )}
                      </div>
                    )}

                    <div className={styles.checkboxGroup}>
                      <label className={styles.checkboxLabel}>
                        <input
                          type="checkbox"
                          checked={isOpportunity}
                          onChange={(e) => setIsOpportunity(e.target.checked)}
                        />
                        <span>¿Es una oportunidad?</span>
                      </label>

                    </div>
                  </div>
                </div>


              </div>


            </AccordionDetails>
          </Accordion>
          <div className={styles.buttonContainer}>
            <ButtonShared
              onPress={handleSave}
              title={loading ? (
                <span>
                  Guardando<span className={styles.dotOne}>.</span><span className={styles.dotTwo}>.</span><span className={styles.dotThree}>.</span>
                </span>
              ) : 'Guardar cambios'}
              primary
              loading={loading}
              disabled={publication?.data?.in_transaction || publication?.data?.reserved || disabled}
            />


            {(publication?.data?.in_transaction || publication?.data?.reserved) && (
              <p className={styles.error}>La publicación está en transacción</p>
            )}


          </div>
        </div>
      </ProfileCard>
      <FeaturesModal
        open={openFeaturesModal}
        onClose={() => setOpenFeaturesModal(false)}
        additionalCharacters={additionalCharacters}
        selectedFeatureIds={selectedFeatureIds}
        setSelectedFeatureIds={setSelectedFeatureIds}
        getAdditionalCharacters={getAdditionalCharacters}
        onSave={handleSaveFeatures}
      />

      {/* Modal para editar imágenes */}
      <PicturesModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        handleDeleteImage={handleDeleteImage}
        handleChangeImage={handleChangeImage}
        pictures={imagesSelected}
        onChangePosition={onChangePosition}
        postPublicationImages={postPublicationsImages}
        loadingReload={updateReducer?.newImages?.fetching}
      />

    </div>
  );
};

export default Edit;